// Tabla de pagos por defecto — cada oficina puede personalizar esto desde el admin
// Los montos son en CLP (pesos chilenos)

export const defaultPayScales = {
  limpieza: {
    title: 'Operador de limpieza',
    icon: '🧹',
    items: [
      { concept: 'Studio', amount: 15420, unit: 'por servicio' },
      { concept: '1 dormitorio', amount: 17028, unit: 'por servicio' },
      { concept: '2 dormitorios', amount: 22896, unit: 'por servicio' },
      { concept: '3 dormitorios', amount: 31982, unit: 'por servicio' },
    ],
    notes: 'El pago se calcula según los metros cuadrados (m²) de la propiedad.',
    process: [
      { title: 'Recibes', desc: 'la asignación con dirección, código y horario en tu app.' },
      { title: 'Llegas', desc: 'a la propiedad y revisas el checklist del tipo de unidad.' },
      { title: 'Limpias', desc: 'según protocolo Impekble (cocina, baño, dormitorios, áreas comunes).' },
      { title: 'Reportas', desc: 'con fotos antes/después y código QR del servicio.' },
      { title: 'Cierras', desc: 'el servicio en la app y queda listo para inspección.' },
    ],
  },
  lavado: {
    title: 'Operador de lavado',
    icon: '🫧',
    items: [
      { concept: 'Sábana superior 2P', amount: 1345, unit: 'c/u' },
      { concept: 'Sábana inferior 2P', amount: 1345, unit: 'c/u' },
      { concept: 'Fundas de almohada (×2)', amount: 336, unit: 'c/u' },
      { concept: 'Cubre plumón', amount: 2017, unit: 'c/u' },
      { concept: 'Toalla de baño (×2)', amount: 1008, unit: 'c/u' },
      { concept: 'Toalla de manos', amount: 336, unit: 'c/u' },
      { concept: 'Toalla de piso', amount: 672, unit: 'c/u' },
    ],
    total: { label: 'Total carga estándar', amount: 8403 },
    notes: 'Los ítems con (×2) se pagan por cada unidad. El total refleja una carga estándar completa.',
    process: [
      { title: 'Retiras', desc: 'la ropa sucia en la bodega Impekble asignada.' },
      { title: 'Lavas', desc: 'a 40–60°C con detergente profesional (sin suavizante en toallas).' },
      { title: 'Secas', desc: 'hasta dejar la ropa con 5–10% de humedad.' },
      { title: 'Planchas, doblas y empaquetas', desc: 'según protocolo, con el código QR visible.' },
      { title: 'Devuelves', desc: 'la ropa limpia al día siguiente en la misma bodega.' },
    ],
  },
  inspector: {
    title: 'Inspector de calidad',
    icon: '🔍',
    items: [
      { concept: 'Inspección post-servicio', amount: 10000, unit: 'por inspección' },
      { concept: 'Auditoría completa de propiedad', amount: 15000, unit: 'por auditoría' },
      { concept: 'Bono 100% visitas asignadas', amount: 30000, unit: 'mensual' },
      { concept: 'Bono cero reclamos (mes siguiente)', amount: 100000, unit: 'mensual' },
    ],
    notes: 'Los inspectores reciben capacitación continua sobre estándares de calidad.',
    process: [
      { title: 'Recibes', desc: 'la lista de propiedades a inspeccionar tras los servicios de limpieza.' },
      { title: 'Visitas', desc: 'y revisas con la pauta Impekble (47 puntos críticos).' },
      { title: 'Documentas', desc: 'desviaciones con foto y nota en cada punto.' },
      { title: 'Validas', desc: 'o devuelves el servicio según el resultado.' },
      { title: 'Envías', desc: 'el reporte; los bonos se acumulan al cierre del mes.' },
    ],
  },
};

// Formatear montos CLP
export function formatCLP(amount) {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
  }).format(amount);
}
